import { FormTemplateQuestionFieldOptionsValidityHintEnum } from 'graphql-common';
import getValidityHintOptions from '@lib/components/TaskCompletions/utils/getValidityHintOptions';

export default function getValidityHintOptionByValue(
  hint: FormTemplateQuestionFieldOptionsValidityHintEnum,
) {
  return getValidityHintOptions().find(({ value }) => value === hint);
}
